/* eslint-disable max-lines */
import { Translation } from 'src/types';

const translations: Translation = {
  translation: {
    Buttons: {
      back: 'Tillbaka',
      changePassword: 'Ändra lösenord',
      copiedVaultId: 'Kopierat!',
      copyVaultID: 'Kopiera Vault ID',
      create: 'Skapa',
      next: 'Nästa',
      notSure: 'Jag är inte säker',
      signUp: 'Registrera dig',
      submit: 'Skicka in',
      updatePassword: 'Uppdatera lösenord',
    },
    Errors: {
      createReportFailed: 'Det gick inte att skapa rapport.',
    },
    ReportStatus: {
      CLOSED: 'Stängd',
      INVESTIGATING: 'Utreder',
      NEW: 'Inskickad',
      READ: 'Läst',
    },
    general: {
      navbar: {
        caseSettings: 'Fallsinställningar',
        changePassword: 'Ändra lösenord',
        logOut: 'Logga ut',
        notifications: 'Notifikationer',
        notificationsDrawer: {
          appFileScanFailed: 'En fil har inte klarat säkerhetskontrollen',
          appReportMatch: 'Ditt GoTogether-register har matchats',
          appReportReassigned: 'En ny ärendehanterare har tilldelats',
          case: 'Fall',
          caseAssigned: 'Fall tilldelat till dig',
          caseImporterJobCompleted: {
            PartialSuccess: 'Din ärendesimport slutfördes med fel',
            failure: 'Din ärendesimport misslyckades',
            success: 'Din ärendehantering har importerats framgångsrikt',
          },
          caseLinked: 'Fall länkat',
          caseTeamInvite: 'Lagt till i ärendet',
          caseUnlinked: 'Fall olänkat',
          dataSanitisation: 'Rapportdetaljer uppdaterade',
          emptyDescription: 'Kolla tillbaka senare för nya aviseringar',
          emptyTitle: 'Du är helt ikapp',
          importId: 'Importera ID:',
          learnMore: 'Lär dig mer',
          markAllAsRead: 'Markera alla som lästa',
          newMessage: 'Nytt meddelande',
          newReport: 'Ny rapport mottagen',
          permissionRemoved: 'Borttagen från ärende',
          postSSubmissionFile: 'Bevisfil(er) tillagda',
          report: 'Rapport',
          reportAssigned: 'Rapport tilldelad till dig',
          reportStatusChange: 'Rapportstatus ändrad',
          reporterAnonymised: 'Dina detaljer har anonymiserats',
          reporterReportSubmitted: {
            subtitle: 'Vi rekommenderar att du sparar en kopia av din rapport',
            title: 'Rapport inlämnad',
          },
          mitigationPlanReminder: 'Godkännande av åtgärdsplan krävs',
          staleCase: 'Obehandlat fall',
        },
        privacyStatement: 'Sekretesspolicy',
        reporter: {
          myReports: 'Mina rapporter',
        },
        settings: 'Inställningar',
        technicalSupport: 'Tekniskt stöd',
        title: 'Konto',
      },
      time: {
        day: 'Dag',
        days: 'Dagar',
        hour: 'Timme',
        hours: 'Timmar',
        minute: 'Minut',
        minutes: 'Minuter',
        second: 'Sekund',
        seconds: 'Sekunder',
      },
    },
    public: {
      ChatContainer: {
        anonymousLabel: 'Anonym',
        autoTranslate: 'Automatisk översättning är avstängd som standard.',
        backToMessages: 'Tillbaka till meddelanden',
        caseSettings: 'Falls inställningar.',
        changeInProfile:
          'Om du önskar ändra denna inställning kan du göra det i din profil',
        deletedByMessage: 'Raderat av {{author}}',
        deletedMessageLabel: 'Detta meddelande har raderats',
        description:
          'När automatisk översättning är aktiverad kommer alla rapportmeddelanden att\n          automatiskt översättas med AI baserat på det standardspråk\n          som är valt på din webbläsare.',
        descriptionSecondHalf:
          'Den ursprungliga versionen av alla meddelanden bevaras alltid och kan hittas i chatten.',
        messagePlaceholder: 'Börja skriva...',
        messageSettings: 'Meddelandeinställningar.',
        originalMessages: 'Original',
        showMoreBanner: 'Lär dig mer om automatiska översättningar',
        titlev2: 'Läs alla meddelanden på ditt föredragna språk.',
        translatedMessageLabel: 'Översatt meddelande',
        translatedMessages: 'Översatt',
        understood: 'Förstått',
      },
      Country: {
        description: 'I vilket land är du stationerad?',
        header: 'I vilket land är du stationerad?',
        noOptions: 'Inga länder hittades',
        other: 'Annat',
        placeholder: 'Sök efter ett land...',
      },
      CreatePublicReport: {
        createReport: 'Skapa ny rapport',
        helpPage: 'Gå till vår hjälpsida',
        loginToOpr: 'Logga in för att spåra rapporter',
        or: 'eller',
        passwordPlaceholder: 'Ange lösenord',
        phoneNumberLoginFailed:
          'Inloggning misslyckades, telefonnummer / pin-kod felaktig',
        phoneNumberPlaceholder: 'Ange ditt telefonnummer',
        phoneNumberTooltip:
          'Ange telefonnumret du använde för att kontakta VaultTalk',
        pinPlaceholder: 'Ange PIN',
        reportIntroductionParagraph1:
          'När du rapporterar en incident kommer du att ställas några frågor för att stödja dig i dokumenteringen av din upplevelse.',
        reportIntroductionParagraph2:
          'Innan du skickar in har du möjligheten att vara anonym för att skydda din integritet.',
        reportIntroductionParagraph3:
          'Efter att du skickat in kan du logga in när som helst för att se framstegen med din rapport & prata med en ärendehanterare.',
        reportIssue: 'Rapportera ett problem',
        usernameLoginFailed:
          'Inloggning misslyckades, användarnamn/lösenord är felaktigt',
        validationError: {
          publicReport: {
            relationshipToCompanyRequired: 'Relation till företaget krävs',
            reportedCategoryRequired: 'Rapporterad kategori krävs',
          },
        },
        vaultId: 'Vault ID',
        vaultIdPlaceholder: 'Ange din E-post eller Vault ID',
        vaultIdTooltip:
          'För anonyma rapporter är Vault ID alfanumeriskt. Om rapporten inte var anonym, är Vault ID din e-postadress.',
        vaultTalk: 'VaultTalk',
        yourPassword: 'Ditt lösenord',
        yourPhoneNumber: 'Ditt telefonnummer',
        yourPin: 'Din 6-siffriga pin-kod',
        yourVaultId: 'Ditt Vault ID',
      },
      CustomHeader: {
        companyLogo: 'Företagslogotyp',
        openReporting: 'Öppna rapportering',
        userSettings: 'Användarinställningar',
      },
      Date: {
        approximateDescription:
          'Minns du ungefär vilket datum händelsen ägde rum?',
        approximatePlaceholder:
          'Exempel: 6 månader sedan/förra året/i november förra året',
        cancel: 'avbryt',
        clear: 'rensa',
        description: 'Minns du vilket datum händelsen ägde rum?',
        header: 'Vilken dag ägde det rum?',
        ok: 'ok',
        placeholder: 'Exempel: 21 juni 2020',
      },
      Description: {
        whatHappened: 'Vad hände?',
        whatHappenedPlaceholder: 'Använd dina egna ord …',
        whatHappenedText: 'Använd dina egna ord för att beskriva vad som hände',
      },
      Details: {
        disclaimer:
          'Dessa detaljer kommer att offentliggöras med din rapport. Om du önskar att förbli anonym, se till att de inte innehåller identifierande information.',
        emailPlaceholder: 'E-post (tillval)',
        fullNamePlaceholder: 'Fullständigt namn (tillval)',
        header: 'Dina uppgifter',
        nonAnonSubtitle:
          'Ange antingen ditt namn eller en e-postadress. Om du vill ta emot meddelanden om denna rapport, lägg till en lämplig e-postadress nedan.',
        nonOptionalEmailPlaceholder: 'E-post',
        nonOptionalFullNamePlaceholder: 'Fullständigt namn',
        subtitle:
          'Om du vill få notifikationer om denna rapport, lägg till en lämplig e-postadress nedan.',
      },
      Emotion: {
        description: 'Hur fick det dig att känna dig? Hur påverkade det dig?',
        header: 'Hur påverkade det dig?',
        placeholder: 'Börja skriva …',
      },
      Evidence: {
        addedHeading: 'Lagt till',
        deletedMessage: 'raderades',
        deletedStatus: 'Raderad',
        failedToOpenFileMessage:
          'Misslyckades med att öppna filen. Vänligen försök igen',
        fileStatuses: {
          infectedUpload: 'Flaggad av säkerhetskontroll',
          passedUpload: 'Godkänd säkerhetskontroll',
          pendingUpload: 'Säkerhetskontroll pågår',
          readyForDownload: 'Redo för nedladdning',
        },
        mobileErrorMessage: 'Flaggade filer: meddela din ärendehanterare',
        nameHeading: 'Namn',
        statusHeading: 'Status',
        tableTitle: 'Bevis',
        webErrorMessage:
          'Flaggade filer: Om din(a) fil(er) har markerats, vänligen meddela ärendehanteraren',
      },
      FileUpload: {
        addFiles: 'Lägg till filer',
        addMoreFiles: 'Lägg till fler filer',
        confirm: 'Bekräfta',
        description:
          'Att lägga till filer som bevis kan bidra till att förbättra effektiviteten i lösningen av ditt ärende av din ärendehanterare. Vänligen överväg filinnehållet (inklusive filmetadata) om du önskar att förbli anonym, och respektera andra individers rättigheter och tillämpliga lagar.',
        dragDrop: 'Släpp filer här eller',
        errorMessage:
          'Fil(er) misslyckades på grund av ett nätverksfel. Klicka nedan för att skicka ett meddelande till din handläggare för att få hjälp.',
        fileLimit: 'Gränsvärde för filstorlek: 100MB',
        fileUploadLimitText: 'Du kan endast ladda upp 10 filer',
        header: 'Lägg till bevis',
        helpArticle: 'hjälp artikel',
        highlighted: 'bläddra i filer',
        information: 'Stödda filtyper',
        moreInformation:
          'För mer information, vänligen se detta <a>hjälp artikel</a>',
        postSubmissionErrorMessage:
          "Vi kunde inte ladda upp dina filer på grund av ett systemfel. Vänligen välj 'bekräfta' igen.",
        tooltipAudio: 'Ljud:',
        tooltipAudioOptions: '.ogg, .wav, .wma',
        tooltipDocuments: 'Dokument:',
        tooltipDocumentsOptions:
          '.ps, .docx, .doc, .pptx, .ppt, .xlsx, .xls, .dcm, .pdf',
        tooltipImage: 'Bilder:',
        tooltipImageOptions:
          '.png, .apng, .jpg, .jpeg, .pjpeg, .svg, .gif, .tiff, .tif, .bmp, .psd, .avif',
        tooltipText: 'Text:',
        tooltipTextOptions: '.txt, .csv, .html, .xml',
        tooltipVideo: 'Video:',
        tooltipVideoOptions: '.mp4, .mov, .mp1s, .asf',
        uploadErrors: {
          invalidFileSize: 'Filen är för stor',
          invalidFileType: 'Filtyp som inte stöds: {{extension}}',
          systemError: 'Systemfel',
          tooManyFiles: 'Maximalt antal filer är {{maxFiles}}',
        },
        uploadFiles: 'Ladda upp filer',
      },
      Loading: {
        loading:
          'Vänligen vänta medan vi skickar din rapport till en ärendehanterare...',
        postSubmissionLoading:
          'Vänligen vänta medan vi skickar in dina fil(er)...',
      },
      Location: {
        description: 'Var inträffade det?',
        header: 'Var inträffade det?',
        placeholder: 'Exempel: På kontoret',
      },
      MessageListBox: {
        messageCaseManager: 'Skicka meddelande till handläggare',
        report: 'Rapportera {{displayReportId}} {{submissionType}}',
      },
      MessageSettings: {
        enableTranslationLabelDisabled: 'Översättning inaktiverad',
        enableTranslationLabelEnabled: 'Översättning aktiverad',
        enableTranslationsDescription:
          'Aktivera automatiska översättningar och läs alla rapportmeddelanden på ditt föredragna språk. Det översatta språket baseras på det språk som är valt på din enhet.',
        enableTranslationsHeader:
          'Aktivera automatiska översättningar för rapportmeddelanden',
        enableTranslationsSubDescriptionv2:
          'Du kan växla mellan det översatta och ursprungliga språket i varje chatt.',
        updateTranslationFailed: 'Uppdatering av översättning misslyckades',
        updateTranslationSuccess:
          'Inställningen för översättning uppdaterades framgångsrikt',
      },
      Password: {
        changePasswordHeader: 'Ändra lösenord',
        createNewPassword: 'Skapa ett nytt lösenord',
        createPasswordHeader: 'Ditt lösenord',
        currentPasswordPlaceholder: 'Ange nuvarande lösenord',
        description:
          'Ett giltigt lösenord måste vara minst 9 tecken långt och innehålla en stor bokstav och en siffra',
        enterCurrentPassword: 'Ange ditt nuvarande lösenord',
        forgottenPasswordInstructions:
          'Ange ditt alfanumeriska Vault ID (inte din e-postadress) och e-postadress för att återställa ditt lösenord.',
        newDescription:
          'Skapa ett starkt lösenord för att hålla ditt konto säkert. Börja skriva för att se riktlinjer nedan.',
        passwordPlaceholder: 'Skapa ett lösenord',
        passwordResetRequestedDescription:
          'Om ditt Vault ID finns i vårt system kommer du att få ett e-postmeddelande med instruktioner för att återställa ditt lösenord.',
        passwordResetRequestedHeader:
          'Länk för återställning av lösenord begärd',
        reenterPlaceholder: 'Ange lösenordet igen',
        subtitle:
          'Skapa ett lösenord för att skicka in denna rapport och få åtkomst till den i framtiden',
        yourVaultId: 'Ditt Vault ID',
        yourVaultIdPlaceholder: 'Ange ditt Vault ID (t.ex. {{exampleId}})',
      },
      Perpetrators: {
        description:
          'Rapporterar du en specifik person eller flera personer? Kan du namnge eller beskriva dem?',
        header: 'Inblandade personer',
        placeholder:
          'Börja skriva och använd ett komma för att lägga till flera namn eller beskrivningar',
      },
      PoweredByVault: 'Drivs av {{company}}',
      PrivacyStatement: 'Produkt Sekretesspolicy',
      PublicMessageList: {
        myMessages: 'Mina meddelanden',
      },
      PublicMoreEvidence: {
        additionalEvidenceHeader: 'Bevis läggs till i befintlig rapport',
        backToReportId: 'Tillbaka till rapport-ID: {{reportId}}',
        description:
          'Att lägga till filer som bevis kan hjälpa till att stödja effektiviteten i lösningen av din ärendehanterare. Vänligen överväg filinnehållet (inklusive filmetadata) om du önskar att förbli anonym, och respektera andra individers rättigheter och tillämpliga lagar. För mer info, vänligen se detta <a>hjälp artikel</a>',
        header: 'Lägg till ytterligare bevis i rapporten',
        vaultTalkOpenCaseHeader: 'Lägg till bevis i din rapport',
      },
      PublicReport: {
        anonymous: 'Anonymt',
        backToReports: 'Tillbaka till rapporter',
        skipped: 'Hoppade över',
      },
      PublicReportCard: {
        addEvidence: 'Lägg till ytterligare bevis',
        messageCaseManager: 'Skicka meddelande till handläggare',
        reportId: 'Rapport-ID:',
        submitted: 'Inskickad',
        vaultTalkClosedCaseCTA: 'Visa bevis',
        vaultTalkOpenCaseCTA: 'Lägg till bevis',
        viewAdditionalEvidence: 'Visa ytterligare bevis',
        viewReport: 'Visa rapport',
      },
      PublicReportsList: {
        reportingSystem: 'Rapporteringssystem',
      },
      Question: {
        placeholder: 'Börja skriva...',
        question: 'Tillhandahålla detaljer',
        questionText:
          'Vänligen dela dina bekymmer, uppdateringar eller förfrågningar med oss.',
      },
      Relationship: {
        header: 'Din relation till organisationen',
        tellUsAbout: 'Berätta för oss din relation med organisationen.',
      },
      ResponsiveNavMenu: {
        messages: 'Mina meddelanden',
        reports: 'Mina rapporter',
      },
      Site: {
        description: 'På vilken plats är du stationerad?',
        header: 'På vilken plats är du stationerad?',
        noOptions: 'Inga platser hittades',
        other: 'Annat',
        placeholder: 'Sök efter en plats...',
      },
      SpamPuzzle: {
        dialog: 'Lös detta problem för att få fortsätta',
      },
      SubmissionTypes: {
        reportIssue: 'Välj en kategori',
        whatType: 'Välj den kategori som bäst beskriver din rapport',
      },
      SubmitSuccess: {
        category: '<bold>Kategori:</bold> {{category}}',
        country: '<bold>Land:</bold> {{country}}',
        dateSubmitted: '<bold>Inlämningsdatum:</bold> {{date}}',
        recordYourVaultID: 'Kom ihåg denna information för inloggning',
        successInformation: 'Mer information',
        successMessage:
          'Din rapport har skickats in och är redo för granskning. Eventuella bifogade filer som kräver uppmärksamhet kommer att markeras vid inloggning. Logga in nedan för att se uppdateringar av rapporten och meddela din ärendehanterare.',
        successSanitationMessage:
          'Spara en kopia för dina handlingar och håll ditt Vault-ID säkert - du kommer att behöva det för att få tillgång till uppdateringar och skicka meddelanden till din ärendehanterare.',
        successSanitationTagline:
          'Din rapport har skickats in och lagrats säkert.',
        successThankYou: 'Tack för din rapport!',
        viewReport: 'Visa rapport',
      },
      Time: {
        approximateDescription:
          'Minns du ungefär vilken tid händelsen ägde rum?',
        approximatePlaceholder: 'Exempel: på morgonen, på eftermiddagen',
        description: 'Minns du vilken tid händelsen ägde rum?',
        header: 'Vilken tid inträffade det?',
        invalidTime: 'Tidsformatet måste vara HH:MM',
      },
      UserSettingsDialog: {
        changePassword: 'Ändra lösenord',
        closeDialog: 'Stäng dialog',
        logout: 'Logga ut',
        messageSettings: 'Meddelandeinställningar',
        userSettings: 'Användarinställningar',
      },
      Witnesses: {
        description:
          'Berättade du för någon annan eller såg någon vad som hände?',
        header: 'Några vittnen?',
        placeholder: 'Börja skriva …',
      },
    },
    reporting: {
      MessageSlideIn: {
        confirmButton: 'Skicka meddelande',
        title: 'Meddelande Ärendehanterare',
        translationHeader: 'Lär dig mer om automatiska översättningar',
      },
      ReportCard: {
        addEvidence: 'Lägg till bevis',
        submissionModeVia: 'via {{inlämningsläge}}',
        viewEvidence: 'Visa bevis',
      },
      ReportList: {
        yourReports: 'Dina rapporter',
      },
      ReportingActivate: {
        buttonText: 'Fortsätt',
        description:
          'Om din organisation har registrerat dig för ett konto skickar vi ett mejl med instruktioner för att slutföra inställningen.',
        emailInput: 'E-post',
        header: 'Ange din arbets-e-post',
        successAccount:
          'Om din organisation har registrerat dig för ett konto, kommer vi att skicka dig ett e-postmeddelande med instruktioner för att slutföra inställningen.',
        successEmail:
          'Om du inte omedelbart ser det, vänta några minuter och uppdatera din e-postinkorg.',
        successHeading: 'Tack',
      },
      ReportingAddEvidence: {
        descriptionHeader: 'Lägg till bevis i din rapport',
        descriptionText:
          'Att lägga till filer som bevis kan hjälpa till att stödja effektiviteten i lösningsprocessen av din ärendehanterare. Var vänlig och tänk på filinnehållet (inklusive filmetadata) om du önskar att förbli anonym, och respektera andra individers rättigheter och tillämpbara lagar. För mer info, var vänlig och se denna <a>hjälp artikel</a>',
        emptyMessage: 'Inga ytterligare bevis uppladdade',
      },
      ReportingChangePassword: {
        back: 'Tillbaka',
        description:
          'Skapa ett starkt lösenord för att hålla ditt konto säkert. Börja skriva för att se riktlinjer nedan.',
        errorToast: 'Kan inte skapa lösenord, ogiltigt token.',
        header: 'Ändra lösenord',
        incorrectCurrentPassword:
          'Det nuvarande lösenordet är fel. Vänligen kontrollera det och försök igen.',
        invalidToken: 'Ogiltigt tecken',
        passwordUpdated: 'Lösenord uppdaterat',
        passwordUpdatedDescription:
          'Ditt lösenord har blivit framgångsrikt uppdaterat. Tack för att du tog detta steg för att hålla dina data säkra!',
        passwordUsedBefore: 'Återanvändning av lösenord är inte tillåtet',
        passwordUsedBeforeDescription:
          'För din säkerhet kan du inte återanvända något av dina sex senaste lösenord. Vänligen välj ett nytt, unikt lösenord för att hålla ditt konto säkert och försök igen.',
        toastDescription:
          'Ditt lösenord har framgångsrikt uppdaterats. Tack för att du tar detta steg för att hålla dina data säkra!',
        toastMessage: 'Lösenord uppdaterat',
        updatePasswordCTA: 'Uppdatera lösenord',
      },
      ReportingConnect: {
        cancelButton: 'Avbryt',
        connectButton: 'Anslut',
        disclaimer:
          'Att koppla ditt Slack-konto till ditt Vault-konto säkerställer en säker och privat anslutning. <br /><br />Genom att ansluta kan du rapportera olämpligt beteende eller ställa en fråga direkt inom Slack. Du kommer alltid att ha möjlighet att rapportera anonymt efter anslutning. Din integritet och säkerhet är våra högsta prioriteringar.',
        heading:
          'Vault Platform begär tillstånd att få åtkomst till ditt {{organisationName}} Slack-konto',
        listHeading: 'Vad kommer Vault att kunna göra?',
        permissionIdentity: {
          extraInfo:
            'Vault kommer att ha förmågan att se din Slack-användares identitet',
          heading: 'Visa information om en användares identitet',
        },
        permissionNotifications: {
          extraInfo:
            'Vault kommer att kunna skicka dig meddelanden till ditt Slack-konto, angående alla uppdateringar till en inlämnad rapport eller fråga',
          heading: 'Skicka dig aviseringar',
        },
        permissionOverview: {
          extraInfo:
            'Vault kommer att visa en översikt över alla inlämningar på startsidan',
          heading: 'Översikt över inlämningar',
        },
        permissionSubmitReport: {
          extraInfo:
            'Detta kommer att ge Vault behörighet att skicka in en rapport eller ställa en fråga, direkt till din organisation, från Slack',
          heading: 'Skicka in en rapport eller fråga för din räkning',
        },
        successfulConnectionDescription:
          'Ditt Vault-konto och Slack-konto är nu kopplade. Du kan nu stänga den här fliken och återgå till Slack.',
        successfulConnectionHeading: 'Framgångsrikt ansluten',
        unsuccessfulConnectionDescription:
          'Något gick fel. Vänligen stäng denna flik och återgå till Slack för att försöka igen.',
        unsuccessfulConnectionHeading: 'Anslutning misslyckades',
      },
      ReportingForgotPassword: {
        description:
          'Ange e-postadressen som är kopplad till ditt konto, och vi skickar dig en länk för att återställa ditt lösenord.',
        heading: 'Glömt lösenord',
        invalidTokenError: 'Kan inte skapa lösenord, ogiltigt token.',
        passwordReuseError: 'Återanvändning av lösenord är inte tillåtet',
        passwordReuseErrorDescription:
          'För din säkerhet kan du inte återanvända något av dina sex senaste lösenord. Vänligen välj ett nytt, unikt lösenord för att hålla ditt konto säkert och försök igen.',
        sendLink: 'Skicka återställningslänk',
        sendLinkFailure: 'Något gick fel',
        sendLinkFailureDescription:
          'Återvänd till <a>Reporter Hub</a> och försök igen. Om problemet kvarstår, kontakta oss på <mailto>techsupport@vaultplatform.com</mailto>',
        sendLinkSuccess: 'Återställningslänk för lösenord skickad',
        sendLinkSuccessDescription:
          'Vi har skickat en länk för att återställa lösenordet till {{email}}',
        updatePasswordSuccess: 'Lösenord uppdaterat',
        updatePasswordSuccessDescription:
          'Ditt lösenord har uppdaterats framgångsrikt. Tack för att du tar detta steg för att hålla dina data säkra!',
      },
      ReportingLogin: {
        accountFrozen: 'Kontot är fryst',
        accountLocked:
          'Inloggning har försökts för många gånger felaktigt. Kontot är låst i upp till 1 timme. Det är inte möjligt att återställa lösenordet under denna tid.',
        accountLockedPermanently:
          'Ditt konto har blivit låst. Använd återställ lösenord för att återfå tillgång eller kontakta din systemadministratör för ytterligare hjälp.',
        createAccountCTA: 'Registrera dig för ett konto',
        currentPassword: 'Nuvarande lösenord',
        emailLabel: 'Din e-post',
        forgotPassword: 'Glömt ditt lösenord?',
        loginButton: 'Logga in',
        newPasswordPlaceholder: 'Nytt lösenord',
        passwordFailMessage:
          'Återgå till Vault-appen i Slack och försök igen. Om problemet kvarstår, kontakta oss på techsupport@vaultplatform.com',
        passwordFailTitle: 'Något gick fel',
        passwordLabel: 'Ditt lösenord',
        passwordPlaceholder: 'Ange ditt lösenord',
        passwordResetRequired: 'Återställning av lösenord krävs',
        passwordSuccessfullySetMessage:
          'Återvänd till Vault-appen i Slack och autentisera med ditt nya lösenord för att fortsätta där du slutade.',
        passwordSuccessfullySetTitle: 'Lösenordet har ställts in framgångsrikt',
        reenterPlaceholder: 'Ange lösenordet igen',
        title: 'Reporter Hub',
        tooltip:
          'Om du aldrig har ställt in ett lösenord för Vault-appen ännu, följ här för att komma igång. Om du har glömt ditt lösenord, använd länken "Glömt lösenord" nedan.',
        usernameLoginFailed:
          'Inloggningen misslyckades, användarnamn eller lösenord är felaktigt',
      },
      ReportingReset: {
        failureDescription:
          'Återgå till Vault-appen i Slack och försök igen. Om problemet kvarstår, kontakta oss på <mailto>techsupport@vaultplatform.com</mailto>',
        failureHeading: 'Något gick fel',
        successDescription:
          'Återvänd till Vault-appen i Slack och autentisera med ditt nya lösenord för att fortsätta där du slutade',
        successHeading: 'Lösenordet har framgångsrikt ställts in',
      },
      noReports: {
        description:
          'Alla inlämnade rapporter kommer att visas här. Lär dig mer om de sätt du kan lämna in en rapport på',
        descriptionHelpArticle: 'denna hjälp artikel',
        errorDescription:
          'Vi kämpar med att ladda dina rapporter. Försök att uppdatera sidan.',
        errorDescriptionSecondary:
          'Om det inte fungerar, var vänlig kontakta oss på',
        errorTitle: '⚠️ Oj, något har blivit fel',
        title: 'Du har inga rapporter ännu',
      },
      settings: {
        messageSettings: {
          autoTranslationDescription1:
            'Aktivera automatiska översättningar och läs alla rapportmeddelanden på ditt föredragna språk. Det översatta språket baseras på det språk som valts på din enhet.',
          autoTranslationDescription2:
            'Du kan växla mellan översatt och originalspråk i varje chatt.',
          autoTranslationTitle:
            'Aktivera automatiska översättningar för rapportmeddelanden',
          header: 'Meddelandeinställningar',
          subHeader: 'Konfigurera hur meddelanden visas',
        },
        notificationSettings: {
          emailDescription:
            'Ta emot e-postmeddelanden för viktiga uppdateringar till dina rapporter',
          emailTitle: 'E-postmeddelanden',
          header: 'Meddelandeinställningar',
          subHeader: 'Konfigurera hur du tar emot notifikationer',
        },
        title: 'Inställningar',
        updatedSettingsFailure:
          'Misslyckades med att uppdatera dina inställningar',
        updatedSettingsSuccess:
          'Dina inställningar har uppdaterats framgångsrikt',
      },
    },
    validators: {
      passwordLength: 'Lösenordet måste vara minst 9 tecken långt',
      passwordLowercase:
        'Lösenordet måste innehålla minst 1 liten bokstav långt',
      passwordMissMatch:
        'Lösenords- och bekräftelsefälten överensstämmer inte.',
      passwordNumeric: 'Lösenordet måste innehålla minst 1 siffra',
      passwordUppercase:
        'Lösenordet måste innehålla minst 1 stor bokstav långt',
    },
    validatorsNew: {
      passwordLength: 'Mellan 10 och 30 tecken',
      passwordLowercase: 'Minst en liten bokstav',
      passwordMissMatch: 'Lösenorden matchar inte',
      passwordNumeric: 'Minst ett nummer',
      passwordSpecialCharacter: 'Minst ett specialtecken',
      passwordUppercase: 'Minst en versal bokstav',
    },
  },
};

export default translations;
